import React,{ createContext, useContext, useState } from "react";
import useInitialState from "../hooks/useInitialState";

export const GlobalContext = createContext();


export const GlobalContextProvider = ({children}) => {
    const initialState = useInitialState()
    return <GlobalContext.Provider value={initialState}>
        {children}
    </GlobalContext.Provider>
}

export const useGlobalContext = () => {
    const context = useContext(GlobalContext)
    if(context === undefined){
        throw new Error('GlobalContext must be used within a GlobalContextProvider')
    }
    return context
}